// extracted by mini-css-extract-plugin
module.exports = {"brandPrimary":"#26b67c","brandSecondary":"#4d2079","upcomingClasses":"style-module__upcomingClasses___1VFR6","header":"style-module__header___2g2K_"};